import React from 'react';

import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof ReactTemplates.TOOLS.upRatingLabel>;
const RatingLabel = (props: Props) => <ReactTemplates.TOOLS.upRatingLabel {...props} />;

export default RatingLabel;
